export const workflow = {
  open: {
    from: 'closed',
    to: 'initial',
  },
  openLocked: {
    from: 'closed',
    to: 'code-remove',
  },
  close: {
    from: [
      'initial',
      'code-set',
      'code-confirmed',
      'code-remove',
      'code-removed',
    ],
    to: 'closed',
  },
  'set-code': {
    from: 'initial',
    to: 'code-set',
  },
  'confirm-code': {
    from: 'code-set',
    to: 'code-confirmed',
  },
  'remove-code': {
    from: 'code-confirmed',
    to: 'code-remove',
  },
  'removed-code': {
    from: 'code-remove',
    to: 'code-removed',
  },
} as const;
